import i from 'i18next'
import { motion } from 'framer-motion'
import { BENELUX_FREE } from './flyouts/Cart'
import { GIFT_1_THRESHOLD } from 'lib/hooks/use-cart'

export default function Shipping({ loaded, onClick }) {
	const items = i
		.t( 'announce.shipping', { threshold: BENELUX_FREE, gift: GIFT_1_THRESHOLD })
		.split( '|' )
		.map( ( s ) => s.trim() )

	return (
		<motion.div
			initial={loaded ? false : { opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1, delay: 0.6 }}
		>
			<ul onClick={onClick} className="shipping">
				{items.map( ( s ) => (
					<li key={s} style={{ whiteSpace: 'nowrap' }}>
						{s}
					</li>
				) )}

			</ul>
			<style jsx>{`
				ul {
					position: relative;
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					border-bottom: solid 1px #e0e4e9;
					font-size: 15px;
					color: #8a8f95;
					text-align: center;
					overflow: hidden;
					text-overflow: ellipsis;
					line-height: 52px;
					cursor: pointer;
					z-index: 1;
					transition: background-color 0.3s;
				}
				li {
					padding: 0 1.5em;
				}
				@media (min-width: 761px) {
					ul:hover {
						background-color: #f7f7f7;
					}
				}
				@media (max-width: 760px) {
					ul {
						height: 52px;
					}
					li {
						position: absolute;
						line-height: 48px;
						white-space: nowrap;
						padding: 0 1.5em;
						width: 100%;
					}

					ul :global(li:first-child) {
						animation: tickerFirst 15s ease-in-out infinite;
					}
					ul li:nth-child(n + 2) {
						opacity: 0;
						animation: ticker 15s ease-in-out infinite;
					}
					ul li:nth-child(2) {
						animation-delay: 4s;
					}
					ul li:nth-child(3) {
						animation-delay: 9s;
					}

					@keyframes tickerFirst {
						0% { transform: translateY(0%); opacity: 1 }
						24% { transform: translateY(0%); opacity: 1 }
						30% { transform: translateY(-100%); opacity: 0 }
						92% { transform: translateY(100%); opacity: 0 }
						98% { transform: translateY(0%); opacity: 1 }
					}
					@keyframes ticker {
						0% { transform: translateY(100%); opacity: 0 }
						6% { transform: translateY(0%); opacity: 1 }
						30% { transform: translateY(0%); opacity: 1 }
						36% { transform: translateY(-100%); opacity: 0 }
						100% { transform: translateY(-100%); opacity: 0 }
					}
				}
			`}</style>
		</motion.div>
	)
}
